import request from '@/utils/request'

// 查询标书风险评估列表
export function listRiskassessment(query) {
  return request({
    url: '/screen/intelligentinspection/riskassessment/list',
    method: 'get',
    params: query
  })
}

// 查询标书风险评估详细
export function getRiskassessment(pid) {
  return request({
    url: '/screen/intelligentinspection/riskassessment/detail/' + pid,
    method: 'get'
  })
}

// 新增标书风险评估
export function addRiskassessment(data) {
  return request({
    url: '/screen/intelligentinspection/riskassessment/add',
    method: 'post',
    data: data
  })
}

// 修改标书风险评估
export function updateRiskassessment(data) {
  return request({
    url: '/screen/intelligentinspection/riskassessment/edit',
    method: 'post',
    data: data
  })
}

// 删除标书风险评估
export function delRiskassessment(pid) {
  return request({
    url: '/screen/intelligentinspection/riskassessment/delete/' + pid,
    method: 'get'
  })
}
